var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.width })},[_c('div',{ref:"myEchart",class:_vm.className,style:({ height: _vm.height, width: '100%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }